var map = {
  "./ru.json": [
    "492946",
    "908084"
  ],
  "./uk.json": [
    "510347",
    "705256"
  ],
  "./bg.json": [
    "158326",
    "838201"
  ],
  "./el.json": [
    "721207",
    "637425"
  ],
  "./en-pt.json": [
    "115946",
    "928755"
  ],
  "./ja.json": [
    "587685",
    "950137"
  ],
  "./sv.json": [
    "813955",
    "576569"
  ],
  "./sr.json": [
    "394962",
    "297425"
  ],
  "./zh-hans.json": [
    "149606",
    "560889"
  ],
  "./lol.json": [
    "634246",
    "75500"
  ],
  "./fr.json": [
    "57675",
    "585091"
  ],
  "./as.json": [
    "607800",
    "833236"
  ],
  "./kk.json": [
    "373929",
    "615607"
  ],
  "./nb.json": [
    "866027",
    "65420"
  ],
  "./uz.json": [
    "944794",
    "161548"
  ],
  "./ky.json": [
    "945398",
    "958509"
  ],
  "./pl.json": [
    "270753",
    "22882"
  ],
  "./ro.json": [
    "519147",
    "784447"
  ],
  "./ka.json": [
    "707768",
    "800868"
  ],
  "./hu.json": [
    "10185",
    "37632"
  ],
  "./hy.json": [
    "927623",
    "69325"
  ],
  "./de.json": [
    "300554",
    "491537"
  ],
  "./vi.json": [
    "841540",
    "543872"
  ],
  "./tr.json": [
    "690374",
    "236005"
  ],
  "./da.json": [
    "823180",
    "24913"
  ],
  "./mr.json": [
    "682559",
    "564921"
  ],
  "./id.json": [
    "982673",
    "991599"
  ],
  "./lt.json": [
    "621046",
    "938440"
  ],
  "./lv.json": [
    "544692",
    "867539"
  ],
  "./es.json": [
    "395434",
    "709726"
  ],
  "./cs.json": [
    "121143",
    "231851"
  ],
  "./boxes.json": [
    "286312",
    "878721"
  ],
  "./sk.json": [
    "586383",
    "503500"
  ],
  "./nl.json": [
    "998625",
    "963932"
  ],
  "./az.json": [
    "64166",
    "306590"
  ],
  "./accents.json": [
    "994369",
    "167251"
  ],
  "./pa.json": [
    "299921",
    "679431"
  ],
  "./pt.json": [
    "694105",
    "826334"
  ],
  "./extra.json": [
    "534906",
    "897835"
  ],
  "./it.json": [
    "15259",
    "945722"
  ],
  "./hi.json": [
    "613962",
    "462073"
  ]
};
function webpackAsyncContext(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__.t(id, 3 | 16);
  });
}

webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 632748;
module.exports = webpackAsyncContext;
